import { render } from "./SpecTypeForm.vue?vue&type=template&id=2129a1fa"
import script from "./SpecTypeForm.vue?vue&type=script&lang=js"
export * from "./SpecTypeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__